module.exports = __webpack_public_path__ + "img/pr-1.9b349810.png";